/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_TransferInputs */

const id_tld_pricing_column_transfer = /** @type {(inputs: Tld_Pricing_Column_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer`)
};

const en_tld_pricing_column_transfer = /** @type {(inputs: Tld_Pricing_Column_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transfer`)
};

/**
* | output |
* | --- |
* | "Transfer" |
*
* @param {Tld_Pricing_Column_TransferInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_transfer = /** @type {((inputs?: Tld_Pricing_Column_TransferInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_TransferInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_transfer(inputs)
	return id_tld_pricing_column_transfer(inputs)
});